// extracted by mini-css-extract-plugin
export default {"buttonContainer":"BackToTopButton-module__buttonContainer__BWYeE"};